<template>
    <span v-if="mostrarBtnDetalheAprovacaoJustificada">
        <span class="text-primary ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Detalhe da Aprovação Justificada"
                @click.stop="mostrarDetalheAprovacaoJustificada()"
            ></i>
        </span>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheAprovacaoJustificada"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da aprovação
            </div>
            <b-row>
                <b-col sm="12" v-if="finalizacao.categoriaAprovacaoJustificada != null">
                    <b-form-group>
                        <label>
                            Categoria da aprovação
                        </label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="finalizacao.categoriaAprovacaoJustificada"
                                :disabled="true"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="finalizacao.detalheAprovacaoJustificada != null">
                    <b-form-group>
                        <label for="contato">Detalhe</label>
                        <b-form-textarea
                            v-model="finalizacao.detalheAprovacaoJustificada"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheAprovacaoJustificada()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { finalizacoesStatus } from './FinalizacoesStatus'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalheAprovacaoJustificada: false
        }
    },

    methods: {
        mostrarDetalheAprovacaoJustificada() {
            this.mostrarModalDetalheAprovacaoJustificada = true
        },

        fecharDetalheAprovacaoJustificada() {
            this.mostrarModalDetalheAprovacaoJustificada = false
        }
    },

    computed: {
        mostrarBtnDetalheAprovacaoJustificada() {
            return (
                this.finalizacao.status === finalizacoesStatus.AGUARDANDO_SETOR_FINANCEIRO ||
                (this.finalizacao.status ===
                    finalizacoesStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO &&
                    !this.isFornecedor)
            )
        },

        isFornecedor() {
            return this.$route.name == 'Credenciados_Finalizacoes_Detalhar'
        }
    }
}
</script>
